import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FirebaseContext from "../firebase/firebaseContext";

const Register = () => {
  const firebaseContext = useContext(FirebaseContext);
  const { auth, db } = firebaseContext;
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [grade, setGrade] = useState("");
  const [alert, setAlert] = useState(false);
  const [email, setEmail] = useState({});

  const register = (e) => {
    e.preventDefault();
    auth
      .createUserWithEmailAndPassword(email.email, password)
      .then((cred) => {
        return db.collection("students").doc(cred.user.uid).set({
          name: name,
          class: grade,
          source: "",
          task: "",
          points: 0,
          id: cred.user.uid,
        });
      })
      .then(() => {
        setAlert(true);
      });
  };

  const confirm = () => {
    setEmail({ email: name + "." + grade + "@bic.si" });
  };

  return (
    <div className='register-container'>
      <h1>USTVARI SI SVOJ ONLINE ZVEZEK</h1>
      <form onSubmit={(e) => register(e)} className='form-register'>
        <label htmlFor='name'>Vpiši ime (brez priimka)</label>
        <input
          type='text'
          className='form-input'
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='Ime'
          required
        />
        <label htmlFor=''>Vpiši geslo (vsaj 6 znakov) </label>
        <input
          type='password'
          title='Geslo mora imeti vsaj 6 črk ali številk'
          pattern='.{6,}'
          className='form-input'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Geslo'
          required
        />
        <label htmlFor=''>Izberi razred</label>
        <select
          value={grade}
          onChange={(e) => {
            setGrade(e.target.value);
          }}
        >
          <option value='0. razred'>Izberi razred</option>

          <option value='6a'>6.a razred</option>
          <option value='6b'>6.b razred</option>

          <option value='7a'>7.a razred</option>
          <option value='7b'>7.b razred</option>

          <option value='8k'>8. razred - Kerstein</option>
          <option value='8u'>8. razred - Uršič</option>
          <option value='8s'>8. razred - Stanko</option>

          <option value='9k'>9. razred - Kerstein</option>
          <option value='9u'>9. razred - Uršič</option>
          <option value='9s'>9. razred - Stanko</option>
        </select>
        <div className='register-obvestilo'>
          TUKAJ JE TVOJE UPORABNIŠKO IME ZA VSTOP. ZAPIŠI ALI KOPIRAJ SI GA.
        </div>
        <div className='register-email'>
          {name}.{grade}@bic.si
        </div>
        <label className='pogoji'>
          Uporabniško ime sem si zapisal. Prav tako se strinjam s{" "}
          <Link to='/pogoji' style={{ color: "blue" }}>
            pogoji uporabe strani.
          </Link>
        </label>
        <input
          type='radio'
          onClick={() => confirm()}
          className='form-button-zapomnil'
        ></input>
        {!email.email ? (
          <button className='form-button-grey' disabled>
            Klikni "strinjam se s pogoji", da lahko nadaljuješ.
          </button>
        ) : (
          <button type='submit' className='form-button'>
            REGISTRIRAJ SE
          </button>
        )}
      </form>
      {alert && (
        <p style={{ fontSize: "2rem", textAlign: "center" }}>
          Uspešno ustvarjen račun. Vrni se na zavihek "ZVEZEK"
        </p>
      )}
    </div>
  );
};

export default Register;
